<template lang="pug">
.homepageSection8Component#purchase
  .sectionContainer
    .left
      .title Подготовьтесь к первому учебному году Вашего ребенка сейчас!
      .text Оформите годовую подписку до 1 июня и получите 3 месяца в подарок
    .right
      .panel
        .title Доступ к предмету на 1 год за&nbsp;689&nbsp;рублей
        .text + 3 месяца в подарок*
        .buttons
          purchase-buttons-block(is-last-section)
      .hint *Предложение доступно при покупке до 1 июня
</template>

<script>
import PurchaseButtonsBlock from './PurchaseButtonsBlock/PurchaseButtonsBlock'

export default {
  components: {
    PurchaseButtonsBlock
  }
}
</script>

<style lang="sass" scoped>
.homepageSection8Component
  background: #ECF4F9
  > .sectionContainer
    display: grid
    grid-template-columns: 1fr 1fr
    grid-gap: 2*$appSidePaddingDesktop

    > .left
      > .title
        font-family: GolosTextWebBold, serif
        font-style: normal
        font-weight: bold
        font-size: 42px
        line-height: 130%
        color: $cDarkBlue
      > .text
        @include font('t16-regular')
        margin-top: 5*$u
        max-width: 80*$u
        @media (max-width: $padWidth)
          text-align: center
          max-width: initial

    > .right
      > .panel
        background: #FFFFFF
        border-radius: 20px
        padding: 7*$u 10*$u 9*$u

        > .title
          font-family: GolosTextWebBold, serif
          font-style: normal
          font-weight: bold
          font-size: 28px
          line-height: 130%

        > .text
          margin-top: 3*$u
          @include font('t16-regular')

        > .buttons
          margin-top: 6*$u

      > .hint
        @include font('t14-regular')
        color: #847F7F
        margin-top: 4*$u

  @media (max-width: $XXXLWidth)
    > .sectionContainer
      grid-gap: $appSidePaddingDesktop
  @media (max-width: 1040px)
    > .sectionContainer
      > .left
        > .title
          font-size: 26px

      > .right
        > .panel
          > .title
            font-size: 26px

  @media (max-width: $padWidth)
    > .sectionContainer
      grid-template-columns: 1fr
    > .sectionContainer
      > .left
        > .title
          text-align: center

  @media (max-width: $XXSWidth)
    > .sectionContainer
      > .right
        > .panel
          padding-left: $appSidePaddingMobile
          padding-right: $appSidePaddingMobile
</style>
